import { CloudProductsReturnType } from './CloudProductsReturnType'
// eslint-disable-next-line no-restricted-imports
import { LocalProductDataContextImplementation } from '../LocalProductDataContextImplementation'

export function useLocalProducts(): CloudProductsReturnType {
  const loadingProductData = false
  const productDataError = null
  const productData = LocalProductDataContextImplementation

  return [loadingProductData, productDataError, productData]
}